/* import __COLOCATED_TEMPLATE__ from './event-part-unknown-entity-component.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { or } from '@ember/object/computed';

export default Component.extend({
  tagName: 'span',
  classNames: ['text-muted'],

  displayText: or('token.label', 'token.value'),
});
